import { render } from "./FooterGlobal.vue?vue&type=template&id=6824c478&scoped=true"
import script from "./FooterGlobal.vue?vue&type=script&lang=js"
export * from "./FooterGlobal.vue?vue&type=script&lang=js"

import "./FooterGlobal.vue?vue&type=style&index=0&id=6824c478&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6824c478"]])

export default __exports__